/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : AiSuggestionHeader.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Typography } from "@mui/material";
import PropTypes from "prop-types";

export default function AISuggestionHeader({
  onClose,
  title,
  subtitle,
  showOnlyTitle = false,
}) {
  return (
    <Box
      sx={{
        background: "#000",
        color: "#fff",
        p: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          textAlign: "start",
          flexDirection: "column",
          display: "flex",
          gap: 1,
        }}
      >
        <Typography variant="body1">{title}</Typography>
        {subtitle && (
          <Typography variant="caption" sx={{ color: "#D9D9D9" }}>
            {subtitle}
          </Typography>
        )}
      </Box>

      <IconButton
        onClick={onClose}
        sx={{
          color: "#fff",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}

AISuggestionHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  showOnlyTitle: PropTypes.bool,
};
